import ZoneAbattagesController from './zone.abattages.controller';

export default {
    template: require('./zone.abattages.tpl.html'),
    controller: ZoneAbattagesController
};
